import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import JobMoveCandidatesPage from '@/features/jobs/job-move-candidates/JobMoveCandidatesPage';
import JobRejectCandidatesPage from '@/features/jobs/job-reject-candidates/JobRejectCandidatesPage';

// EU-551/EU-552 — wizards bulk acessados pelos cards "Movimentar candidatos" e
// "Reprovar candidatos" da Gestão de vaga (EU-560).
export const jobMoveCandidatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/movimentar',
  component: JobMoveCandidatesPage,
});

export const jobRejectCandidatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/$jobId/reprovar',
  component: JobRejectCandidatesPage,
});
